export default {
    'daily-report': 'التقرير اليومي',
    'visit-details': 'تفاصيل الزيارة',
    'distributed-samples': 'المواد الموزعة'
}